export enum ReportReason {
  DontLikeIt,
  Spam,
  Nudity,
  HateSpeech,
  Bullying,
  Scam,
  False,
  IPViolation,
  Other,
}

/** @see https://www.figma.com/file/UESQ6qWJtCaQUxNKw0TEmF/Community?type=design&node-id=5333-101136&t=6mvKQnYOQsTQdHGy-0 */
export const ReportReasonDictionary: Record<ReportReason, string> = {
  [ReportReason.DontLikeIt]: 'I just don’t like it',
  [ReportReason.Spam]: 'It’s spam',
  [ReportReason.Nudity]: 'Nudity or sexual activity',
  [ReportReason.HateSpeech]: 'Hate speech or symbols',
  [ReportReason.Bullying]: 'Bullying or harassment',
  [ReportReason.Scam]: 'Scam or fraud',
  [ReportReason.False]: 'False information',
  [ReportReason.IPViolation]: 'Intellectual property violation',
  [ReportReason.Other]: 'Other',
};
